module.exports = __webpack_public_path__ + "static/img/6.d64e883.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/6.png
// module id = t3Xk
// module chunks = 0